function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Button from '@profile/src/Components/Button';
import { Breakpoint, useBreakpoint } from '@profile/src/utils/breakpoints';
const TIME_OUT = 60;

const CodeButton = ({
  timestamp,
  loading,
  onClick,
  className,
  disabled,
  ...props
}) => {
  const breakpoint = useBreakpoint();
  const timerRef = React.useRef();
  const duration = React.useMemo(() => {
    if (timestamp) {
      const now = Date.now();
      const old = new Date(timestamp).valueOf();
      const diffTime = Math.abs(now - old);
      return Math.ceil(diffTime / 1000);
    }

    return TIME_OUT;
  }, [timestamp]);
  const remainTime = duration > TIME_OUT ? 0 : TIME_OUT - duration;
  const [count, setCount] = React.useState(remainTime);
  React.useEffect(() => {
    if (count <= 0 && timerRef.current) {
      clearInterval(timerRef.current);
    }
  }, [count]);
  React.useEffect(() => {
    if (remainTime > 0 && remainTime <= TIME_OUT && timestamp) {
      setCount(remainTime);
      timerRef.current && clearInterval(timerRef.current);
      timerRef.current = setInterval(() => {
        setCount(prev => prev - 1);
      }, 1000);
    }

    return () => {
      timerRef.current && clearInterval(timerRef.current);
    };
  }, [remainTime, timestamp]);
  const active = count <= 0;
  const titleButton = !active ? `Resend code in ${count}s` : breakpoint !== Breakpoint.PHONE ? 'Send code via email' : 'Send code';
  return /*#__PURE__*/React.createElement(Button, _extends({
    disabled: disabled || !active,
    className: className,
    title: titleButton,
    onClick: onClick,
    loading: loading
  }, props));
};

export default CodeButton;